/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Reset_Password_TitleInputs */

const en_common_sign_reset_password_title = /** @type {(inputs: Common_Sign_Reset_Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset password`)
};

/**
* | output |
* | --- |
* | "Reset password" |
*
* @param {Common_Sign_Reset_Password_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_reset_password_title = /** @type {((inputs?: Common_Sign_Reset_Password_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Reset_Password_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_reset_password_title(inputs)
});
export { common_sign_reset_password_title as "common.sign.reset_password_title" }